import axios from '../utils/axios';

export default function fetchPublishedJobsCount(adminId,params) {
    return (
        axios.get('/admin/' + adminId + '/published-jobs/count',{
            params: params
        })
    )
}
